<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <h1>Update Multiple Flight Times</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="box">
                        <div class="row p-4">
                            <div class="col-md-3">
                                <div class="form-group">
                                  <label for="departure-time" class="form-label">Departure From Date</label>
                                  <dateTimePicker
                                      no-label
                                      label="Departure From Date"
                                      id="departure_date"
                                        format="YYYY-MM-DD"
                                        formatted="YYYY-MM-DD"
                                        button-color="#ec391e"
                                        color="#ec391e"
                                        :only-date="true"
                                        v-model="flight_filter.date_range.from"
                                        style="border: 1px solid #DFE5F9"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                  <label for="departure-time" class="form-label">Departure To Date</label>
                                  <dateTimePicker
                                      no-label
                                      label="Departure To Date"
                                        id="departure_date"
                                        format="YYYY-MM-DD"
                                        formatted="YYYY-MM-DD"
                                        button-color="#ec391e"
                                        color="#ec391e"
                                        :only-date="true"
                                        v-model="flight_filter.date_range.to"
                                        style="border: 1px solid #DFE5F9"
                                    />
                                </div>
                            </div>
                            <div class="col-md-2 mt-4">
                                <button class="button" @click="fetchFilteredFlightData">Fetch Data</button>
                            </div>
                        </div>
                    </div>        
                </div>
            </div>
            <div class="box mt-5">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="table">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Booking Ref</th>
                                        <th>Flight Number</th>
                                        <th>Old Departure Airport</th>
                                        <th>Old Departure Time</th>
                                        <th>Old Arrival Airport</th>
                                        <th>Old Arrival Time</th>
                                        <th>New Departure Airport</th>
                                        <th>New Departure Time</th>
                                        <th>New Arrival Airport</th>
                                        <th>New Arrival Time</th>
                                        <th>Cached At</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="booking_flight_details.length > 0">
                                        <template v-for="(booking, index) in booking_flight_details">
                                            <template v-if="booking.flights_changed.length > 0">
                                                <template v-for="(flight,fligh_index ) in booking.flights_changed">
                                                    <tr :key="fligh_index" :style="(fligh_index === 0) ? 'border-top: 4px solid black;' : ''">
                                                        <td><template v-if="fligh_index === 0"> {{ booking.booking_ref }}</template></td>
                                                        <td>{{ flight.flight_number }}</td>
                                                        <td>
                                                            <span class="text-primary">{{ flight.old_departure_airport }}</span>
                                                        </td>
                                                        <td>
                                                            <span class="text-primary">{{ flight.old_departure_time | formatTimeShort }}</span>
                                                        </td>
                                                        <td>
                                                            <span class="text-primary">{{ flight.old_arrival_airport }}</span>
                                                        </td>
                                                        <td>
                                                            <span class="text-primary">{{ flight.old_arrival_time | formatTimeShort }}</span>
                                                        </td>
                                                        <td>
                                                            <span class="text-primary">{{ flight.new_departure_airport }}</span>
                                                        </td>
                                                        <td>
                                                            <template v-if="flight.is_new_departure_equal">
                                                                <span class="text-success">{{ flight.new_departure_time | formatTimeShort }}</span>
                                                            </template>
                                                            <template v-else>
                                                                <span class="text-danger heartbeat">{{ flight.new_departure_time | formatTimeShort }}</span>
                                                            </template>
                                                        </td>
                                                        <td>
                                                            <span class="text-primary">{{ flight.new_arrival_airport }}</span>
                                                        </td>
                                                        <td>
                                                            <template v-if="flight.is_new_arrival_equal">
                                                                <span class="text-success">{{ flight.new_arrival_time | formatTimeShort }}</span>
                                                            </template>
                                                            <template v-else>
                                                                <span class="text-danger heartbeat">{{ flight.new_arrival_time | formatTimeShort }}</span>
                                                            </template>
                                                        </td>
                                                        <td>
                                                            <template v-if="flight.last_cached_at">
                                                                <span class="text-muted">{{ flight.last_cached_at | formatDateTime }}</span>
                                                            </template>
    
                                                        </td>
                                                        <td>
                                                            <template v-if="fligh_index === 0">
                                                                <button class="button button--primary" @click="updateFlightTime(booking)">
                                                                    <span>Update</span>
                                                                </button>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr :key="index">
                                                    <td colspan="12" class="text-center">No flight changes found for booking {{ booking.booking_ref }}.</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="12" class="text-center">No flight details found.</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Email to Customer Modal -->
        <div class="modal-lg" v-if="showEmailCustomerModal == true">
        <EmailCustomerModal 
            @sendEmailToCustomer="updateFlightWithEmail" 
            :mailtemplates="emailTemplates" 
            :selectedDocuments="selectedDocuments"
            :bookingChangeReasons="bookingChangeReasons" 
            :notifyCustomer="true"
        />
        <button type="button" class="icon icon--unlink" v-on:click="showEmailCustomerModal = false">Close</button>
        </div>
        <div class="modal__bg" v-if="showEmailCustomerModal == true"></div>
    </div>
</template>

<script>
import Errors from '@/components/Errors.vue'
import EmailCustomerModal from '@/components/EmailCustomerModal.vue'

export default {
    name: 'FlightTimeBulkUpdate',
    components: {
        Errors,
        EmailCustomerModal
    },
    created() {
        let token = this.$route.query.token;
        if (token) {
            let decodedStr = atob(token);
            const formElems = new URLSearchParams(decodedStr);
            console.log(formElems.toString());
            this.updateRecord = true;
            if (formElems.has('booking_ref')) {
                this.flight_filter.booking_reference = [formElems.get('booking_ref')];
            }

            if (formElems.has('booking_references')) {
                this.flight_filter.booking_reference = formElems.get('booking_references').split(',');
            }

            if (formElems.has('flight_ids')) {
                this.flight_filter.default_selected_ids = formElems.get('flight_ids').split(',');
            }

            if (formElems.has('booking_id')) {
                this.flight_filter.booking = formElems.get('booking_id');
            }

            if (formElems.has('update_time')) {
                this.updateAllRecords = formElems.get('update_time') === 'true';
            }

            this.fetchFlightDetails();
            
        }

    },
    data() {
        return {
            flight_filter: {
                booking_reference: [],
                date_range: {
                    to: null,
                    from: null
                },
            },
            booking_flight_details: [],
            showEmailCustomerModal: false,
            emailTemplates: [],
            selectedDocuments: [],
            bookingChangeReasons: [],
            selectedRecords: [],
            updateRecord:false,
            updateAllRecords: false
        }
    },
    methods: {
        fetchFilteredFlightData() {
            this.$router.replace({ query: {} });
            this.updateAllRecords = false;
            this.flight_filter.booking_reference = []
            this.fetchFlightDetails();
        },
        fetchFlightDetails() {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'flights/get/multiple-flights/data', {
                method: 'POST',
                body: JSON.stringify({
                    booking_reference:this.flight_filter.booking_reference,
                    date_from: this.flight_filter.date_range.from,
                    date_to: this.flight_filter.date_range.to,
                }),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.$store.dispatch('setLoadStatus')
                if (response.status) {
                    this.booking_flight_details = response.flights_data;
                    this.emailTemplates = response.email_templates;
                    this.bookingChangeReasons = response.booking_change_reasons;

                    let recordsExists = false;
                    this.booking_flight_details.forEach(booking => {
                        if (booking.flights_changed.length > 0) {
                            recordsExists = true;
                        }
                    });
                    /**
                     * If We've been redirected from the excel with the Update all Flag
                     */
                    if (recordsExists && (this.updateRecord || this.updateAllRecords)) {
                        this.$swal({
                            title: "Info",
                            text: "You are updating the flight times of all the flights listed. Do you wish to notify customers about these Flight Changes?",
                            icon: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes!"
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.setSelectedRecords().then(() => {
                                    this.showEmailCustomerModal = true;
                                })
                            } else {
                                this.setSelectedRecords().then(() => {
                                    this.triggerFlightChange();
                                })
                            }
                        })
                    }

                }    
                
            });
        },
        updateFlightTime(record) {
            this.$swal({
                title: "Info",
                text: "Do you wish to notify customer about this Flight Change?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setSelectedRecords(record).then(() => {
                        this.showEmailCustomerModal = true;
                    })
                } else {
                    this.setSelectedRecords(record).then(() => {
                        this.triggerFlightChange();
                    })
                }
            })
        },
        updateFlightWithEmail(template,intimateCustomer = false, selectedReasons = []) {
            let emailToCustomer = { template, intimateCustomer, selectedReasons }
            this.triggerFlightChange(emailToCustomer);
        },
        triggerFlightChange(emailToCustomer = {}) {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'tours/instances/update/instance-multiple-flight-time', {
                method: 'POST',
                body: JSON.stringify({
                    selectedRecords: this.selectedRecords,
                    emailToCustomer
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.$store.dispatch('setLoadStatus')
                if (response.status) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                    this.showEmailCustomerModal = false;
                    this.fetchFlightDetails();
                } else {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
            });
        },
        setSelectedRecords(record = null) {
            let self = this
            return new Promise((resolve) => {
                if (record) {
                    self.selectedRecords.push(record);
                } else {
                    
                    self.booking_flight_details.forEach(booking => {
                        let updateObject = []
                        booking.flights_changed.forEach(flight => {
                            updateObject.push({...flight})
                        });
                        self.selectedRecords.push({
                            booking_ref: booking.booking_ref,
                            flights: updateObject
                        })
                    });
                }
                resolve(true)
            });
        }
    }        
}
</script>
<style scoped>
.heartbeat {
    animation: heartbeat 1.5s infinite;
}
@keyframes heartbeat {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  25% {
    transform: scale(1.2);
    opacity: 0.6;
  }
  40% {
    transform: scale(0.95);
    opacity: 1;
  }
  60% {
    transform: scale(1.15);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>